import { t } from '@lingui/core/macro'
import _ from 'lodash'
import { qrCodeCustomizationOptions, integrationName } from './config'

const {
  qrCodeUseShortened,
  qrCodeSize,
  qrCodeConfig,
  qrCodeBackground,
  qrCodeXOffset,
  qrCodeYOffset,
} = qrCodeCustomizationOptions

const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1)

export const isValidJson = (str, cb) => {
  try {
    JSON.parse(str)
  } catch (e) {
    cb(e)
    return false
  }
  return true
}

export const getNameAndAccountErrors = inputs => {
  const nameAndAccountErrors = Object.keys(inputs)
    .map(name => {
      if (inputs[name]) {
        return {}
      }
      return {
        type: 'ERROR',
        message: name === 'name' ? 'Name is required' : 'Account is required',
        reference: {
          step: 'connect',
          id: name,
        },
      }
    })
    .filter(e => !_.isEmpty(e))

  return nameAndAccountErrors
}

export const getMetadataErrors = (inputs, jsonValidated) => {
  const metadataErrors = Object.keys(inputs.metadata)
    .map(name => {
      if (name === qrCodeSize) {
        if (inputs.metadata.qr_code_monkey_size < 300) {
          return {
            type: 'ERROR',
            message: t`The minimum size for QR codes is 300px`,
            reference: {
              step: 'connect',
              id: name,
            },
          }
        }
      }

      if (
        inputs.metadata[name] ||
        name === qrCodeUseShortened ||
        name === qrCodeConfig ||
        name === qrCodeBackground ||
        name === qrCodeXOffset ||
        name === qrCodeYOffset
      ) {
        if (name === qrCodeConfig && !jsonValidated) {
          return {
            type: 'ERROR',
            message: t`${integrationName} configuration must be validated`,
            reference: {
              step: 'connect',
              id: 'jsonValidated',
            },
          }
        }
        return {}
      }
      const metaDataName = capitalizeFirstLetter(name.split('_').pop())
      return {
        type: 'ERROR',
        message: t`${metaDataName} is required`,
        reference: {
          step: 'connect',
          id: name,
        },
      }
    })
    .filter(e => !_.isEmpty(e))

  return metadataErrors
}
